

function Pending() {
  return (
    <div>Pending</div>
  )
}

export default Pending